<template>
  <div class="freight-table-carriers-filters">
    <a-input-search
      v-model="searchValue"
      placeholder="Busque pela transportadora"
      class="freight-table-carriers-filters__search"
      allow-clear
      @search="emitFilterChange"
      @change="onInputChange"
    >
      <a-icon slot="prefix" type="search" style="color: rgba(0, 0, 0, 0.25)" />
    </a-input-search>

    <div class="freight-table-carriers-filters__actions">
      <a-button
        class="freight-table-carriers-filters__btn"
        @click="$emit('open-filters')"
      >
        <a-icon type="control" /> Filtros
      </a-button>

      <FreightTableActionsMenu
        :items="bulkActions"
        :disabled="!hasSelection"
        @select="$emit('bulk-action', $event)"
      />
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import FreightTableActionsMenu from "../FreightTableActionsMenu.vue";

const BULK_ACTIONS = [
  { key: "activate", label: "Ativar", icon: "check-circle" },
  { key: "inactivate", label: "Inativar", icon: "minus-circle" },
];

export default {
  name: "FreightTableCarriersFilters",
  components: { FreightTableActionsMenu },
  props: {
    hasSelection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchValue: "",
      bulkActions: BULK_ACTIONS,
    };
  },
  created() {
    this.debouncedEmit = debounce(this.emitFilterChange, 500);
  },
  beforeDestroy() {
    this.debouncedEmit.cancel();
  },
  methods: {
    onInputChange() {
      this.debouncedEmit();
    },
    emitFilterChange() {
      this.$emit("filter-change", { search: this.searchValue });
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-carriers-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  &__search {
    width: @details-search-width;

    /deep/ .ant-input {
      border-radius: 6px;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__btn {
    border-radius: 6px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: @color-text-medium;
  }
}
</style>
